const days = [
	{
		name: '今天',
		code: 'day1'
	},
	{
		name: '明天',
		code: 'day2'
	},
	{
		name: '后天',
		code: 'day3'
	}
]
const timeQuantum = [
	{
		begin: '08:00',
		end: '09:00'
	},
	{
		begin: '09:00',
		end: '10:00'
	},
	{
		begin: '10:00',
		end: '11:00'
	},
	{
		begin: '11:00',
		end: '12:00'
	},
	{
		begin: '12:00',
		end: '13:00'
	},
	{
		begin: '13:00',
		end: '14:00'
	},
	{
		begin: '14:00',
		end: '15:00'
	},
	{
		begin: '15:00',
		end: '16:00'
	},
	{
		begin: '16:00',
		end: '17:00'
	},
	{
		begin: '17:00',
		end: '18:00'
	},
	{
		begin: '18:00',
		end: '19:00'
	},
	{
		begin: '19:00',
		end: '20:00'
	}
]

export {
	days,
	timeQuantum
}



// WEBPACK FOOTER //
// ./src/components/time-picker/config.js